// 指我们内部接口人对外包方提交的版本文件进行审核后，产出的迭代意见，也指内外部接口人针对该迭代意见进行的回复（暂未规划）。一个完整的反馈信息会包括：预览内容、批注反馈、富文本反馈

import { UploadFile } from 'antd';
import { UploadFileObjType, User } from 'common/types';
import { VideoTransform } from './playControl';

export interface AttachmentFile extends Partial<UploadFile> {
  fileName?: string;
  url?: string;
}
export interface CommentForm {
  content: string;
  attachment: AttachmentFile[];
  isChecked: boolean;
}
export enum CommentStatus {
  AllStatus = 'ALL_STATUS',
  PendingPublish = 'PENDING_PUBLISH',
  NotPass = 'NOT_PASS',
  PendingInternal = 'PENDING_INTERNAL_CHECK',
  Pass = 'PASS',
  PendingDiscussion = 'PENDING_DISCUSSION',
}

export enum CommentSourceType {
  CheckResult = 'CHECK_RESULT',
  Animation = 'ANIMATION',
  Video = 'VIDEO',
  Normal = 'NORMAL',
  Text = 'TEXT', //纯文本反馈
  Other = '', //兼容旧数据
}

export interface CommentAssetPosition {
  uniqueId: number;
  fileId: string;
  url: string;
  frameIndex: number;
  frameTime?: string;
  takeIndex: number;
  takeName?: string;
  snapShot: any; // 其他所有的变量
  playerTransform: VideoTransform;
  isLinkedAnnotation?: boolean; //是否携带预览内容
  fileName?: string; // 导出反馈的文件名称列表（未转换前的文件）
  hasAnnotation?: boolean; //是否有绘制内容
  createTime: string; // 创建时间
}

export interface Comment {
  uniqueId: number;
  content: string | { checkList: any[] }; // 评论内容，可能是json object，或者富文本
  preview?: UploadFileObjType; // 预览图，新版fos改为文件对象
  type: CommentSourceType;
  attachment?: AttachmentFile[]; // 需求附件
  creator?: User;
  createTime: string;
  updateTime: string;
  annotation?: {
    mainImage?: string;
    stage?: any;
    images?: Record<string, string>;
  };
  version?: string; // 依赖版本
  isFullScreen?: boolean;
  popo?: string;
  assetPosition: CommentAssetPosition;
  isSyncingToServer?: boolean;
  isUpdateError?: boolean;
  extra?: any;
}

export interface ExcelCommentRow {
  uniqueId: number | string;
  content: string; // 评论内容，可能是文本，或者富文本
  preview?: string; // 预览图
  hasAttachment?: string; // 需求附件
  creatorName?: string;
  createTime: string;
  version?: string; // 依赖版本
  fileName?: string;
  assetPositionTip?: string;
}

export interface Annotation {
  mainImage: string;
  stage?: any;
  images?: Record<string, string>;
  pluginName: string | null; //当前的插件名称
}
export interface CachedCommentWithTTL {
  ttl: number;
  content: string; // 评论内容，可能是文本，或者富文本
  preview?: string; // 预览图
  createUser: string;
  createTime: string;
  annotation: Annotation;
  version: number; // 依赖版本id
  taskId: number;
}

export enum CommentsMode {
  SINGLEMODE = 'single-col',
  DOUBLEMODE = 'double-col',
}
export enum AspectType {
  aspectFill = 'aspect-fill',
  aspectFit = 'aspect-fit',
}
export enum CommentOrderBy {
  TIME = 'time',
  FRAME = 'frame',
}
export enum CommentFilterBy {
  ALL = 'all',
  FILE = 'file',
}
